import React from 'react';

import Icon from './Icon';
import Button, { ButtonStyles } from './Button';
import {
	PAGE_LANDING,
	PAGE_SERP_LIST,
	PAGE_SERP_MAP,
	TC_EVENT_NAMES
} from '../utils/Constants';

import { useTCLog } from '../utils/TCEvent';

import { SHOW_RANKED_BUTTON } from '../api/portletConfiguration';

export default function MapControlsButton({
	page,
	onPageChange,
	rankedSearch,
	isMunicipality,
	onToggleFilters,
	showFiltersButton,
	setRankedSorting
}) {
	const [TCLog] = useTCLog();

	const mapControlsStyle = {
		padding: '9px 20px',
		fontWeight: 600
	};

	const rankButtonStyle = {
		padding: '9px 20px',
		fontWeight: 600,
		borderBottom: 0
	};

	return (
		<>
			{showFiltersButton ? (
				<Button
					variant={ButtonStyles.SECONDARY}
					icon={<Icon textOn="right" icon="icon/filtro_blue.png" />}
					text="Filtri"
					style={mapControlsStyle}
					onClick={onToggleFilters}
					type="button"
				/>
			) : null}

			<Button
				variant={ButtonStyles.SECONDARY}
				icon={
					<Icon
						textOn="right"
						icon={
							page === PAGE_SERP_MAP
								? 'icon/lista_blue.png'
								: 'icon/mappa_blue.png'
						}
					/>
				}
				text={page === PAGE_SERP_MAP ? 'Lista' : 'Mappa'}
				style={mapControlsStyle}
				onClick={() => {
					TCLog(
						page === PAGE_SERP_MAP ? 'LISTA' : 'TORNA_ALLA_MAPPA'
					);
					if (page !== PAGE_SERP_MAP && setRankedSorting) {
						setRankedSorting(false);
					}
					onPageChange(
						page === PAGE_SERP_MAP ? PAGE_SERP_LIST : PAGE_SERP_MAP
					);
				}}
				type="button"
				show={page !== PAGE_SERP_MAP}
			/>

			<Button
				variant={ButtonStyles.SPECIAL}
				icon={<Icon textOn="right" icon="icon/suggeriti_white.png" />}
				text="Agenzie suggerite"
				style={rankButtonStyle}
				onClick={() => {
					if (setRankedSorting) {
						setRankedSorting(true);
					}
					onPageChange(
						page === PAGE_SERP_MAP ? PAGE_SERP_LIST : PAGE_SERP_MAP
					);
				}}
				type="button"
				show={SHOW_RANKED_BUTTON && page === PAGE_SERP_MAP}
			/>
		</>
	);
}
